<template>
    <div :id="id" :name="name" :class="['headline', { active }]" @click="handleClick">
        <i :class="iconClass"></i>
        <span class="headline-name">{{ truncatedName }}</span>
        <span class="headline-number">({{ limitedNumber }})</span>
    </div>
</template>

<script>
export default {
    name: 'Headline',
    props: {
        iconClass: {
            type: String,
            required: false,
        },
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        number: {
            type: [Number],
            required: false,
        },
        active: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        truncatedName() {
            return this.name.length > 28 ? this.name.slice(0, 50) + '...' : this.name;
        },
        limitedNumber() {
            return this.number > 99 ? '99+' : this.number;
        }
    },
    methods: {
        handleClick() {
            this.$emit('clicked');
        }
  }
}
</script>

<style scoped>
.headline {
  display: flex;
  align-items: center;
  padding: 10px 10px;
  font-size: 14px;
  /* border: 1px solid var(--gray); */
  border-bottom: 3px solid var(--light);
  border-radius: 10px 10px 10px 10px;
  background-color: var(--white);
  transition: border-color 0.3s ease-in-out;
  cursor: pointer;
}

.headline.active {
  border-bottom-color: var(--purple); /* Highlighted bottom border when active */
}

i {
  margin-right: 10px;
}

.headline-name {
  margin-right: auto;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.headline-number {
  color: var(--dark);
  padding: 3px 8px;
  border-radius: 20px; /* Round shape for the number */
  font-size: 14px;
}
</style>